// extracted by mini-css-extract-plugin
module.exports = {"product-list":"ProductList_product-list__srWyd","product-list__item":"ProductList_product-list__item__EGiXh"};